import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {FunktionsbereichEntfernenPage} from './funktionsbereich-entfernen.page';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';

const routes: Routes = [
    {
        path: '',
        component: FunktionsbereichEntfernenPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        SopiComponentsModule.forRoot(),
        SopiScrollModule
    ],
    declarations: [FunktionsbereichEntfernenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FunktionsbereichEntfernenPageModule {
    public static forRoot(): ModuleWithProviders<FunktionsbereichEntfernenPageModule> {
        return {
            ngModule: FunktionsbereichEntfernenPageModule,
            providers: []
        };
    }
}
